import { createStore } from "vuex";
import Main from "./modules/Main";
import Step1 from "./modules/Step1";
import Step2 from "./modules/Step2";
import Step3 from "./modules/Step3";
import Step4 from "./modules/Step4";
import Step5 from "./modules/Step5";
import Step6 from "./modules/Step6";
import MapDormitory from "./modules/MapDormitory";
export default createStore({
  modules: { Main, Step1, Step2, Step3, Step4, Step5, Step6, MapDormitory },
});
